import React from 'react';
import Label from 'components/form/Label/Label';
import './AccountMixSummaryModule.scss';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import AccountMixSummaryColumn from './AccountMixSummaryColumn';
import ProgressAccountMix from 'components/AccountMixDial/ProgressAccountMix';
import { useConfig } from 'hook/config.hook';
import { useSelector } from 'react-redux';
import AccountMixSummaryShowModal from './AccountMixSummaryShowModal';
import useAccountMixSummary from './hooks/accountmixsummary.hook';
import AccountMixLeyendRow from './AccountMixLeyendRow';
import { Link } from 'components/navigation/Link/Link';

const AddIncome = () => {
  return (
    <FlexContainer
      className={
        ' primary_cta_bg_light borderRadius4 width60px height17px items-align-center justify-center pointer'
      }
    >
      <Label type={'text-8 fontBlack'}>ADD INCOME</Label>
    </FlexContainer>
  );
};

const AccountMixSummaryModuleController = props => {
  const { creditInfo } = props;
  const { creditScoreAnalysis } = creditInfo;
  const { accountMix } = creditScoreAnalysis;
  const { additionalData } = props;
  const { accountMixSummary } = additionalData;

  const {
    income,
    isOpenModal,
    loading,
    onChangeTotalAnnualIncome,
    onSaveHandle,
    handleModal,
  } = useAccountMixSummary();

  const { selectedFactorGrade } = useSelector(state => ({
    selectedFactorGrade:
      state?.score1b3bFactorDial?.factor?.selectedFactorGrade,
  }));

  const columnLeft = [
    {
      img: 'CreditCard',
      title: 'Credit cards',
      value: accountMixSummary?.totalOpenCcAccounts,
    },
    {
      img: 'AutoLoans',
      title: 'Auto loans',
      value: accountMixSummary?.totalOpenAutoLoanAccounts,
    },
    {
      img: 'HomeLoans',
      title: 'Home loans',
      value: accountMixSummary?.totalOpenHomeLoanAccounts,
    },
  ];

  const columnRight = [
    {
      img: 'OtherLoans',
      title: 'Other loans',
      value: accountMixSummary?.totalOpenOtherLoanAccounts,
    },
    {
      img: 'StudentLoans',
      title: 'Student loans',
      value: accountMixSummary?.totalOpenStudentLoanAccounts,
    },
    {
      img: 'RentalTradeline',
      title: 'Rental tradeline',
      value: accountMixSummary?.totalOpenRentalAccounts,
    },
  ];

  const { config } = useConfig();
  const label =
    config?.summaryHeaders?.ACCOUNT_MIX?.[selectedFactorGrade || 'DEFAULT'];

  const { msg, linkText, linkUrl } =
    config?.summaryTooltips?.ACCOUNT_MIX?.DTIMessage;

  const counterAccounts = () => {
    let total = 0;
    columnLeft.map((column, index) => {
      if (column?.value !== 0) {
        total++;
      }
      return total;
    });

    columnRight.map((column, index) => {
      if (column?.value !== 0) {
        total++;
      }
      return total;
    });

    return total;
  };

  const isPercent = accountMixSummary?.debtToIncomeRatio ? '100' : '0';
  const isAddIncome = accountMixSummary?.debtToIncomeRatio ? (
    `${accountMixSummary?.debtToIncomeRatio}%`
  ) : (
    <AddIncome />
  );

  const isUpdate = accountMixSummary?.debtToIncomeRatio ? (
    'Update income'
  ) : (
    <></>
  );

  return (
    <>
      <FlexContainer className={'flex-column padLR48 m-padLR16'}>
        <FlexContainer className={'flex-column'}>
          <Label type={'padTB24 Body-2'}>{label}</Label>
          <AccountMixSummaryColumn
            countAccounts={accountMix?.totalOpenAccount}
            countAccTypes={counterAccounts()}
            columnLeft={columnLeft}
            columnRight={columnRight}
          />
        </FlexContainer>
        <FlexContainer className={'padT24'}>
          <FlexContainer>
            <ProgressAccountMix
              size={'small'}
              success={accountMixSummary?.debtToIncomeRatio}
              percent={isPercent}
              strokeColor={{
                '100%': '#134ea6',
              }}
              percentClass={'H5'}
              dti
            />
          </FlexContainer>
          <FlexContainer
            className={'flex-column width100 gap-4 height40px padL20'}
          >
            <AccountMixLeyendRow
              labelLeft="Total Debt"
              labelRight={`$${accountMixSummary?.totalDebt?.toLocaleString()}`}
            />
            <AccountMixLeyendRow
              labelLeft="Total Montly Payments"
              labelRight={`$${accountMixSummary?.totalMonthlyPayments?.toLocaleString()}`}
            />
            <AccountMixLeyendRow
              labelLeft="Debt to Income Ratio"
              labelRight={isAddIncome}
              onClick={handleModal}
            />
            <AccountMixLeyendRow
              labelLeft="How is this calculated?"
              labelRight={isUpdate}
              dontDottedLine
              labelClass={`${'secondary_text_light'} pointer`}
              onClick={handleModal}
            />
          </FlexContainer>
        </FlexContainer>
        <FlexContainer>
          <Label className="text-12 margT16">
            {msg + ' '}
            {linkUrl && (
              <a
                href={linkUrl}
                target="_blank"
                className={`${'secondary_text_light'} pointer`}
              >
                {linkText}
              </a>
            )}
          </Label>
        </FlexContainer>
      </FlexContainer>
      <AccountMixSummaryShowModal
        isOpenModal={isOpenModal}
        onCancel={handleModal}
        income={income}
        onChangeTotalAnnualIncome={onChangeTotalAnnualIncome}
        onOk={onSaveHandle}
        config={props.config}
        loading={loading}
      />
    </>
  );
};
export default AccountMixSummaryModuleController;
